import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import { PaymentPaypalInterface } from 'modules/profile/payment-gateways/integrations/paypal-soap/types'
import httpClient from 'shared/utils/http-client'

export const paypalConnect = (data: PaymentPaypalInterface) =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/pay-pal/connect`, data)

export const paypalDisconnect = () => httpClient.post(`${PAYMENT_GATEWAYS_API}/pay-pal/disconnect`)
